import React, { useEffect, useState } from "react";
import { api, resolveImageUrl } from "../../lib/api";
import { Handshake, ExternalLink, Phone, Mail, Tag, Copy, CheckCircle2 } from "lucide-react";

export default function Kooperationspartner() {
  const [items, setItems] = useState([]);
  const [copied, setCopied] = useState(null);

  useEffect(() => { api.get("/kooperationspartner").then((r) => setItems(r.data)); }, []);

  const copy = async (code, id) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(id);
      setTimeout(() => setCopied(null), 1800);
    } catch {}
  };

  const grouped = items.reduce((acc, p) => {
    const k = p.kategorie || "Sonstiges";
    (acc[k] = acc[k] || []).push(p);
    return acc;
  }, {});

  return (
    <div className="space-y-6" data-testid="partner-page">
      <div>
        <h1 className="text-3xl font-heading font-bold text-falke-blue inline-flex items-center gap-2"><Handshake /> Kooperationspartner</h1>
        <p className="text-falke-anthracite/70 mt-1">Exklusive Vorteile von FalkeTek-Partnern für unsere Kunden.</p>
      </div>

      {Object.keys(grouped).length === 0 ? (
        <div className="falke-card p-8 text-center text-falke-anthracite/60">
          <Handshake className="mx-auto opacity-30 mb-2" size={36} />
          Noch keine Partner verfügbar.
        </div>
      ) : (
        Object.entries(grouped).map(([kat, list]) => (
          <div key={kat} className="space-y-3">
            <h2 className="text-base font-heading text-falke-blue/80 uppercase tracking-wider">{kat}</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {list.map((p) => (
                <div key={p.id} className="falke-card p-5 falke-card-hover" data-testid={`partner-${p.id}`}>
                  <div className="flex items-center gap-3 mb-3">
                    {p.logo_url ? (
                      <img src={resolveImageUrl(p.logo_url)} alt={p.name} className="w-12 h-12 rounded-lg object-contain bg-white" />
                    ) : (
                      <div className="w-12 h-12 rounded-lg bg-falke-blue/10 flex items-center justify-center text-falke-blue font-bold">{p.name[0]}</div>
                    )}
                    <div className="min-w-0 flex-1">
                      <div className="font-heading font-semibold text-falke-blue truncate">{p.name}</div>
                      <div className="text-xs text-falke-anthracite/60 truncate">{p.kategorie}</div>
                    </div>
                  </div>
                  <p className="text-sm text-falke-anthracite/80 line-clamp-3 mb-3">{p.beschreibung}</p>

                  {p.rabatt_text && (
                    <div className="mb-3 p-2.5 rounded-lg bg-falke-orange/10 border border-falke-orange/25">
                      <div className="text-xs text-falke-orange font-bold uppercase tracking-wide inline-flex items-center gap-1"><Tag size={11} /> FalkeTek Vorteil</div>
                      <div className="text-sm font-semibold text-falke-anthracite mt-0.5">{p.rabatt_text}</div>
                      {p.rabatt_code && (
                        <button onClick={() => copy(p.rabatt_code, p.id)} className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-mono bg-white px-2 py-1 rounded border border-falke-orange/30 hover:bg-falke-orange/5" data-testid={`partner-copy-${p.id}`}>
                          {copied === p.id ? <CheckCircle2 size={12} className="text-emerald-500" /> : <Copy size={12} />}
                          {copied === p.id ? "kopiert!" : p.rabatt_code}
                        </button>
                      )}
                    </div>
                  )}

                  <div className="flex flex-wrap gap-2 text-sm">
                    {p.website && <a href={p.website} target="_blank" rel="noreferrer" className="text-falke-blue hover:text-falke-orange inline-flex items-center gap-1"><ExternalLink size={13} /> Website</a>}
                    {p.email && <a href={`mailto:${p.email}`} className="text-falke-blue hover:text-falke-orange inline-flex items-center gap-1"><Mail size={13} /> Mail</a>}
                    {p.telefon && <a href={`tel:${p.telefon}`} className="text-falke-blue hover:text-falke-orange inline-flex items-center gap-1"><Phone size={13} /> Tel</a>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
